import React, { useState, useEffect, useCallback } from 'react'
import {
  requestProductCategories,
  requestProductCategoriesUpdate,
  requestProductCategoriesCreate,
} from 'requests/product-categories'
import { newProductCategory } from 'constants/objects/product-category'
import { PRODUCTS_SUBMENU } from 'constants/menu/submenus'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { ProductCategory } from './components/ProductCategory'
import { Form } from './components/Form'

export default function ProductCategoriesList() {
  const [categories, setCategories] = useState([])
  const [responseError, setResponseError] = useState()
  const [pagination, setPagination] = useState()
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [currentCategory, setCurrentCategory] = useState(null)
  const [saving, setSaving] = useState(false)

  const getCategories = useCallback(async () => {
    const response = await requestProductCategories()
    setLoading(false)

    if (response.error) return setResponseError(response)

    setPagination(response.meta?.pagination)
    return setCategories(response.data)
  }, [])

  useEffect(() => {
    getCategories()
  }, [getCategories])

  const onCategoryUpdate = async (params) => {
    setSaving(true)
    const resp = await requestProductCategoriesUpdate(
      currentCategory.id,
      params,
    )

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    setCurrentCategory(null)
    return getCategories()
  }

  const onCategoryCreate = async (params) => {
    setSaving(true)
    const resp = await requestProductCategoriesCreate(params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    return getCategories()
  }

  const onSave = (params) => {
    if (!currentCategory?.id) {
      return onCategoryCreate(params)
    }

    return onCategoryUpdate(params)
  }

  const onSelectCategory = (category) => {
    setCurrentCategory(category)
    setShowForm(true)
  }

  const onToggleForm = (show = false) => {
    if (!show) setCurrentCategory(null)
    setResponseError(null)
    setShowForm(show)
  }

  const renderForm = () => (
    <Form
      category={currentCategory || newProductCategory}
      onCancel={() => onToggleForm(false)}
      onSave={onSave}
      saving={saving}
      responseError={responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={PRODUCTS_SUBMENU} />
  )

  const renderCategory = (category) => (
    <ProductCategory
      key={`product-category-list-${category.id}`}
      category={category}
      onClick={onSelectCategory}
    />
  )

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Categoria de produtos"
      onClickPagination={() => {}}
      pagination={pagination}
      loading={loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
    >
      { categories.map(renderCategory) }
    </ListPage>
  )
}
